<template>
	<inertia-head title="Dashboard" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">FB Group Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Management</h2>
				</div>
			</div>
		</div>
	</div>

	<modal ref="modal" size="modal-md">
		<template #title>
			FB Profile Change History
		</template>
		<template #body>
			<div class="row">
				<div v-for="(fb,f_index) in selectedFbProfileLogs" class="col-12">
					<div class="fw-bold">{{fb.changed_at}}</div>
					<p>
						<a :href="fb.fblink" target="_blank" class="text-info">{{fb.fblink}}</a>
					</p>
				</div>
			</div>
		</template>
	</modal>

	<div class="content">
		<!-- <div class="text-end mb-4">
			<button @click="viewMemberModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Content
			</button>
		</div> -->
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title me-5">
					<form @submit.prevent="searchRecord(0)">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group mb-4">
									<flat-pickr
										v-model="date_start"
										id="date_start"
										class="form-select"
										placeholder="Select start date"
									/>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group mb-4">
									<flat-pickr
										v-model="date_end"
										id="date_end"
										class="form-select"
										placeholder="Select end date"
									/>
								</div>
							</div>
							<div class="col space-x-1 mb-2">
								<button type="submit" class="btn btn-alt-primary">
									<i class="fa fa-search me-1"></i>Display
								</button>
								<button
									@click="searchRecord(1)"
									type="button"
									class="btn btn-alt-secondary"
								>
									<i class="fa fa-retweet me-1"></i>Reset
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
			<div class="block-header">
				<div class="block-title me-5">
					<form @submit.prevent="searchMember">
						<div class="input-group">
							<input type="text" v-model="search" id="search" name="search" class="form-control" placeholder="Search"/>
							<div class="input-group-prepend">
								<span class="input-group-btn">
									<button type="submit" id="btnSearch" name="btnSearch" class="btn btn-info"><i class="fa fa-search me-1"></i>Search</button>
								</span>
							</div>
						</div>
					</form>
				</div>
				<div class="block-options">
					<div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Filter By</span></div>
						<select v-model="filter" class="form-control">
							<option value="null">All</option>
							<option value="active">Active</option>
							<option value="expired">Expired</option>
						</select>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<!-- Pagination -->
				<pagination v-if="members.data.length > 0" :collections="members"/>
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>EMAIL</th>
								<th>FIRST NAME</th>
								<th>LAST NAME</th>
								<th>EXPIRED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(member, m_index) in members.data"
								:key="member.sub_content_id"
							>
								<td>{{member.username}}
									<span class="badge me-1"
									:class="{
										'bg-info':member.current_rank=='SILVER',
										'bg-primary':member.current_rank=='GOLD',
										'bg-warning':member.current_rank=='DIAMOND',
										'bg-success':member.current_rank=='PLATINUM',
										'bg-flat':member.current_rank=='PLATINUM COUPLE',
										'bg-earth':member.current_rank=='PLATINUM FAITHFUL',
										'bg-elegance':member.current_rank=='BCC'
									}"
									>{{member.current_rank}} {{member.add_alias}}</span>
									<div class="fs-sm">FB LINK: 
										<span v-if="member.c_fblink!==null">
											<a :href="member.c_fblink" class="text-info" target="_blank">{{member.c_fblink}}</a>
											<a v-if="member.fb_profile_logs.length>1" @click="selectFbProfileLogs(m_index)" href="javascript:void()" class="ms-2 text-warning">View Changes</a>
										</span>
										<span v-if="member.c_fblink==null" class="text-danger">NONE</span>
									</div>
								</td>
								<td>{{member.fname}}</td>
								<td>{{member.lname}}</td>
								<td>
									<div><sub>{{member.expiry_format}}</sub></div>
									<span :class="{'text-danger':member.expired=='Yes','text-success':member.expired=='No'}">{{member.expired}}</span>
								</td>
								<td class="text-end">
									<button @click="viewMemberModal(m_index,'view')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-search"></i></button>
								</td>
							</tr>
							<tr v-if="members.data.length <= 0">
								<td colspan="5" class="mb-0 fw-semibold text-center p-5">No Member Found.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="members.data.length > 0" :collections="members"/>
			</div>
		</div>
		<fb-group-management ref="fbGroupManagementModal" :social-groups="socialGroups" :content="selectedMember"/>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import FbGroupManagement from '../../../Components/Admin/FbGroupManagement'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		members		: Object,
		socialGroups: Object,
		api_response: Object,
		errors 		: Object,
		filter 		: String
	},
	components:{FbGroupManagement},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const modal = ref(null);

		const filter = ref(props.filter);

		const search = ref('');

		const action = ref('add');

		const toast = createToaster();

		const selectedMember 		= reactive({});

		const selectedFbProfileLogs = ref(null);

		const fbGroupManagementModal = ref(null);

		const selectFbProfileLogs =(_index)=>{
			selectedFbProfileLogs.value = props.members.data[_index].fb_profile_logs;
			modal.value.toggleModal();
		}

		const searchRecord = (_is_reset) => {

							if(_is_reset==1)
							{
								date_start.value 	= "";
								date_end.value 		= "";
							}

							Inertia.get(
								route('admin.fb-group-management'),
								{
									date_start	: date_start.value,
									date_end 	: date_end.value
								},
								{
									preserveState: true,
									preserveScroll: true,
									only: ['members']
								}
							)
						}

		const viewMemberModal = (_index,_action)=>{
			
			action.value = _action;
			
			selectedMember.member_id 		= props.members.data[_index].counter;
			selectedMember.member_uuid 		= props.members.data[_index].member_uuid;
			selectedMember.username 		= props.members.data[_index].username;
			selectedMember.current_rank 	= props.members.data[_index].current_rank;
			selectedMember.fname 			= props.members.data[_index].fname;
			selectedMember.lname 			= props.members.data[_index].lname;
			selectedMember.expired 			= props.members.data[_index].expired;
			selectedMember.c_fblink 		= props.members.data[_index].c_fblink;

			fbGroupManagementModal.value.setMember(selectedMember);

			fbGroupManagementModal.value.toggleModal();

		}

		const searchMember =()=>{

			var param = {search:search.value};

			Inertia.get(
						'fb-group-management', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['members','filter']
						}
					)
		}

		watch(filter, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {filter:value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'fb-group-management', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['members','filter']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action=='add' ? 'added' : 'updated';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			modal,
			filter,
			search,
			action,
			toast,
			searchRecord,
			searchMember,
			viewMemberModal,
			selectedMember,
			selectFbProfileLogs,
			selectedFbProfileLogs,
			fbGroupManagementModal
		}
	},
}
</script>
